import { OffersMessages } from '../customer-app-content.types';

export const offersMessagesData: OffersMessages = {
  offerList: {
    offers: [
      {
        distributedOfferId: 'f44a9cd6-2e70-4e1f-a822-8be56901452c',
        offerId: '53793ece-be50-450d-a285-6644ade13ca9',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.1918d5f6-a71b-4b22-95b4-810dcddc236e',
        codeFormat: 'QRCODE',
        title: 'New Offer - Auto message Andrew',
        shortDescription: 'Auto message Andrew',
        longDescription: 'Auto message Andrew',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_c7cdb06a4c294cf9bd2b4a8a4903dfa7.png',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_5fccf47840554d5c8b467f8bc9996ffd.png',
        status: 'NEW',
        distributedDate: '2023-06-22T01:30:37',
        updatedDate: '2023-06-22T01:30:37',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: '7597ddab-32d9-43d2-81ed-347ce33e4ba2',
        offerId: 'e2753a39-5f6b-461c-9bd1-42797c12dfaf',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.03844911-2a05-4169-9975-b61d55c6156f',
        codeFormat: 'QRCODE',
        title: 'Saved Offer - Auto message andrew',
        shortDescription: 'Auto message andrew',
        longDescription: 'Auto message andrew',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_c744596d8b1d4aaeb82f60c2db2afbc9.png',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_9b74b20f49c64b8c8e912848faec3079.png',
        status: 'SAVED',
        distributedDate: '2023-06-21T11:00:22',
        updatedDate: '2023-06-21T11:00:22',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: '9ab796da-61ae-4655-bfe6-c4382d581e0f',
        offerId: '53793ece-be50-450d-a285-6644ade13ca9',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.1918d5f6-a71b-4b22-95b4-810dcddc236e',
        codeFormat: 'QRCODE',
        title: 'Read Offer - Auto message Andrew',
        shortDescription: 'Auto message Andrew',
        longDescription: 'Auto message Andrew',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_c7cdb06a4c294cf9bd2b4a8a4903dfa7.png',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_5fccf47840554d5c8b467f8bc9996ffd.png',
        status: 'READ',
        distributedDate: '2023-06-21T10:30:27',
        updatedDate: '2023-06-21T10:30:27',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: '8bd53435-cfbb-4cde-8aa9-ccce24bf2a91',
        offerId: '53793ece-be50-450d-a285-6644ade13ca9',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.1918d5f6-a71b-4b22-95b4-810dcddc236e',
        codeFormat: 'QRCODE',
        title: 'System Redeemed Offer - Auto message Andrew',
        shortDescription: 'Auto message Andrew',
        longDescription: 'Auto message Andrew',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_c7cdb06a4c294cf9bd2b4a8a4903dfa7.png',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Referral-Banner-Codexxa_5fccf47840554d5c8b467f8bc9996ffd.png',
        status: 'SYSTEM_REDEEMED',
        distributedDate: '2023-06-21T09:42:07',
        updatedDate: '2023-06-21T09:42:07',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: '96419e5f-20fc-4bd8-a159-f36f57a8e4d4',
        offerId: 'f60ac18d-137f-4294-a0a8-3d24398332fa',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.49b66d1a-84a7-4e33-84ec-f6325e3ae6e5',
        codeFormat: 'QRCODE',
        title:
          'User Redeemed Offer - 21/06 Never Expire>>Single Lifetime>>Item level',
        shortDescription: '21/06 Never Expire>>Single Lifetime>>Item level',
        longDescription: '21/06 Never Expire>>Single Lifetime>>Item level',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/images%20%286%29_ec8a7bdae5cb40c2a8297abc93f9d068.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/images%20%286%29_b423ddd9250f4d97a4a0f0ab913bd56a.jpg',
        status: 'USER_REDEEMED',
        distributedDate: '2023-06-21T08:50:11',
        updatedDate: '2023-06-21T08:50:11',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: '28a13bf2-60d7-42a7-b818-32596ebb25bd',
        offerId: 'b6edc8e0-5f2a-4584-91dc-916ec89109f6',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.97f6894d-f4db-4093-98df-0ef12f439341',
        codeFormat: 'QRCODE',
        title: 'Loyalty Offer - test offer - 20/06',
        shortDescription: 'test offer - 20/06',
        longDescription: 'test offer - 20/06',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/kimchi-pork-burgers-XL-RECIPE0517-b1f47495c16a45e995a886963ec433c9_bbc1e0f3757248ebbab9814dc1ce6b45.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/frenchfryfbready_29a65b26155a43bea4f19be858f2dc88.png',
        status: 'NEW',
        redemptionEndDate: '2023-07-11T10:09:24',
        distributedDate: '2023-06-20T10:09:24',
        updatedDate: '2023-06-20T10:09:24',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: true,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: '28a13bf2-60d7-42a7-b818-32596ebb25be',
        offerId: 'b6edc8e0-5f2a-4584-91dc-916ec89109f6',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.97f6894d-f4db-4093-98df-0ef12f439341',
        codeFormat: 'QRCODE',
        title: 'Loyalty Offer - Guest Promo Code',
        shortDescription: 'Loyalty Offer - Guest Promo Code',
        longDescription: 'Loyalty Offer - Guest Promo Code',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/kimchi-pork-burgers-XL-RECIPE0517-b1f47495c16a45e995a886963ec433c9_bbc1e0f3757248ebbab9814dc1ce6b45.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/frenchfryfbready_29a65b26155a43bea4f19be858f2dc88.png',
        status: 'NEW',
        redemptionEndDate: '2023-07-11T10:09:24',
        distributedDate: '2023-06-20T10:09:24',
        updatedDate: '2023-06-20T10:09:24',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: true,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: true,
      },
      {
        distributedOfferId: '979e0e2a-6290-4a30-906c-0bebda5e24ab',
        offerId: 'b3b75cfd-6138-4764-a1e1-ba7677f1d9c0',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.2065f205-2cf1-4e4e-ac28-1104483e4c04',
        codeFormat: 'QRCODE',
        title: 'Universal Offer - Modifier offer June 7',
        shortDescription: 'Modifier offer June 7',
        longDescription: 'Modifier offer June 7',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/ee_768e24a48d3f48f9a5cfd2d1c90bf87b.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/ee_aa74fcb3bcf44e7bb211d0d8369ae428.jpg',
        status: 'NEW',
        distributedDate: '2023-06-16T09:26:52',
        updatedDate: '2023-06-16T09:26:52',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: true,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: '9f119a30-7367-447f-8871-b1068424ae6f',
        offerId: 'edf4d6dd-94da-4cac-930e-86ab3828b3ab',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.a50383d1-f95a-48a0-b235-1033c2aaa18a',
        codeFormat: 'QRCODE',
        title: 'Toast 10% Modifier level offer - 04/12',
        shortDescription: 'Toast 10% Modifier level offer - 04/12',
        longDescription: 'Toast 10% Modifier level offer - 04/12',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/chicken-devil_d5f24a54113a4029b62679409d3133b8.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/chicken-devil_6fb7e35c58e44bbfb79da0beb4c49716.jpg',
        status: 'NEW',
        distributedDate: '2023-06-15T09:20:27',
        updatedDate: '2023-06-15T09:20:27',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
      {
        distributedOfferId: 'a6c90f12-8121-4918-aa5f-a91882c2400e',
        offerId: 'd3a15478-0392-41ae-81b9-9d0306da1f78',
        clientId: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        offerCode: 'palmlanedev.f2388518-8ad4-47d3-9903-56d79a0c4ea3',
        codeFormat: 'QRCODE',
        title: 'Hesh offer SQL',
        shortDescription: 'Hesh offer SQL',
        longDescription: 'Hesh offer SQL',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/20-1_61b71cafa8794d2695c1002cf3819fc7.JPG',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/20-1_572b3741a1ff4954a5d5cc033fa039d9.JPG',
        status: 'NEW',
        distributedDate: '2023-06-15T09:20:27',
        updatedDate: '2023-06-15T09:20:27',
        redeemType: 'PURCHASE',
        purchaseTypes: ['INTEGRATED'],
        alwaysAvailable: false,
        isLoyaltyOffer: false,
        universalOffer: false,
        enableGuestCheckout: false,
      },
    ],
    paging: {
      total: 585,
      count: 10,
      totalPages: 59,
      currentPage: 0,
    },
  },
  messageList: {
    messages: [
      {
        distributedMessageId: '2215b4db-75a1-42c7-8732-73ca4697a270',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: '0dbe23a6-a8db-4326-8029-cd2ad61ef078',
        languageCode: 'EN',
        title: '%Tharuni NE Message - 0005%',
        shortDescription: '%Tharuni NE Message - 0005%',
        longDescription: '%Tharuni NE Message - 0005%',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/custard-pudding-00_994e8d8f29364e898b5263c6ded1b233.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/custard-pudding-00_d565f49ddc0c4feab58c450d8e7cb467.jpg',
        status: 'NEW',
        distributedDate: '2023-06-22T14:07:07',
        updatedDate: '2023-06-22T14:07:07',
        messageType: 'PRIVATE',
      },
      {
        distributedMessageId: '295047d8-f0c1-4d6b-ae2e-2d131011c6bf',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: '3e4a6fc9-7135-492f-bdf1-17638519ada0',
        languageCode: 'EN',
        title: 'WOV2 Smoke - Survay - Hesh',
        shortDescription: 'WOV2 Smoke - Survay - Hesh Short',
        longDescription:
          'Open your mobile app, or click <a href="https://order.incentiviodev.com/c/palmlanedev">here</a> and sign in to your account to answer the survey in your inbox (click the three bars on the top left and then click "Inbox").',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/survay_6c752918a87c456ea0c5a7b89afc3771.JPG',
        mediumImage: '',
        status: 'READ',
        distributedDate: '2023-06-15T09:20:24',
        updatedDate: '2023-06-15T09:20:24',
        messageType: 'SURVEY',
        surveyId: '6234574ad3d7dc345ce359c4',
      },
      {
        distributedMessageId: '6faefad5-683b-4c11-9d90-58992253f9a9',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: '57f5ac0c-e181-450a-bf93-628c32815806',
        languageCode: 'EN',
        title: 'WOV2 Smoke - Shareable Message - Hesh',
        shortDescription: 'WOV2 Smoke - Shareable Message - Hesh short',
        longDescription: 'WOV2 Smoke - Shareable Message - Hesh long',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/share_8a770815167d4591b0f606baa9267868.JPG',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/share_2f7ea4a9e1b24080a5ba83cd3a0390db.JPG',
        status: 'EXPIRED',
        distributedDate: '2023-06-15T09:20:24',
        updatedDate: '2023-06-15T09:20:24',
        messageType: 'SHAREABLE',
      },
      {
        distributedMessageId: 'c5a71ca1-6732-4e89-9267-b01668e7cf98',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: 'b17b0bad-71eb-48f3-9b14-0bd7fae86ab3',
        languageCode: 'EN',
        title: 'WOV2 Smoke - Private Message - Hesh',
        shortDescription: 'WOV2 Smoke - Private Message - Hesh Short',
        longDescription: 'WOV2 Smoke - Private Message - Hesh Long',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/Private_289bd722c24b4916868cc5cf7260fa61.JPG',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/Private_1ef923ecb17e43e29d90f8a1008093c2.JPG',
        status: 'DELETED',
        distributedDate: '2023-06-15T09:20:24',
        updatedDate: '2023-06-15T09:20:24',
        messageType: 'PRIVATE',
      },
      {
        distributedMessageId: '9fd5e189-50a2-4367-84d2-836b87fe5221',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: 'bb94e606-cd90-4556-acf2-7982d98fb134',
        languageCode: 'EN',
        title: 'Auto message testing for parameter changes - 05/31',
        shortDescription: 'Auto message testing for parameter changes - 05/31',
        longDescription: 'Auto message testing for parameter changes - 05/31',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/Picture2_5e8e84bc9ee44b6ba1ece0925553a893.png',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/Picture2_a7e4488d8341498091c23c6bfb2a75b0.png',
        status: 'NEW',
        distributedDate: '2023-05-31T07:25:43',
        updatedDate: '2023-05-31T07:25:43',
        messageType: 'PRIVATE',
      },
      {
        distributedMessageId: '41d558ab-8924-478e-87ea-0772965d5585',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: '22f34455-dec5-4500-8277-72a0b6da909b',
        languageCode: 'EN',
        title: 'Auto Static message- SL expire 23/05',
        shortDescription: 'Auto Static message- SL expire 23/05',
        longDescription: 'Auto Static message- SL expire 23/05',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/png-clipart-strawberries-and-drink-illustration-strawberry-juice-frutti-di-bosco-strawberry-juice-cream-frutti-di-bosco-thumbnail_925c5d9721774e708e0c0f190a9f25e5.png',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/png-clipart-strawberries-and-drink-illustration-strawberry-juice-frutti-di-bosco-strawberry-juice-cream-frutti-di-bosco-thumbnail_3a85fac9d9c54ed782d46c6f9372e60e.png',
        status: 'NEW',
        distributedDate: '2023-05-23T12:53:37',
        updatedDate: '2023-05-23T12:53:37',
        messageType: 'PRIVATE',
      },
      {
        distributedMessageId: 'd890d924-9bf7-47e8-ba31-cfb76265e181',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: '55d51c54-582d-44e0-b5ee-d7e6dfad0621',
        languageCode: 'EN',
        title: 'Transaction Complete MESSAGE- 1 May',
        shortDescription: 'Transaction Complete MESSAGE- 1 May',
        longDescription: 'Transaction Complete MESSAGE- 1 May',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/11_ee3ff1cb9ea5468cbf551a6001734968.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/11_c5bb75e9c4e84f0490d20a55923b5c1d.jpg',
        status: 'NEW',
        distributedDate: '2023-05-10T05:09:11',
        updatedDate: '2023-05-10T05:09:11',
        messageType: 'SHAREABLE',
      },
      {
        distributedMessageId: 'f9087bf3-0696-43a9-826a-5c2104222732',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: 'c322a990-7f53-49e2-89fe-f42fa8a7ff45',
        languageCode: 'EN',
        title: 'Test auto msg 3',
        shortDescription: 'fsdfsfsfsfsdf',
        longDescription: 'sdfsfsfsdfsdf',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/download_560b9ee807804b4a8d4a157e7e9a074b.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/download_49ca39a9d6a14987828a129f25f3f8bd.jpg',
        status: 'NEW',
        distributedDate: '2023-04-24T13:43:14',
        updatedDate: '2023-04-24T13:43:14',
        messageType: 'SHAREABLE',
      },
      {
        distributedMessageId: '48cfb615-15b9-4982-85e8-70112654c5bf',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: '877ff462-ad7e-4f17-843c-8f0a7fd820b0',
        languageCode: 'EN',
        title: 'Never Expire Message Testing - 15/11/22 SMS test 2',
        shortDescription: 'Never Expire Message Testing - 15/11/22 SMS test 2',
        longDescription: 'Never Expire Message Testing - 15/11/22 SMS test 2',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/22_f65156f5f8fb40d0ba5878eb0c0e8bec.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/22_0b8791114af24e0abef7151d1575eb73.jpg',
        status: 'READ',
        distributedDate: '2023-03-27T03:32:38',
        updatedDate: '2023-03-27T03:32:38',
        messageType: 'SHAREABLE',
      },
      {
        distributedMessageId: '66648957-dda5-45ea-9aa3-38e7b71167be',
        merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
        messageId: 'bad084c2-bc49-4889-b613-eda9efbb1924',
        languageCode: 'EN',
        title: 'Never Expire Message Testing - 15/11/22 SMS',
        shortDescription: 'Never Expire Message Testing - 15/11/22 SMS',
        longDescription: 'Never Expire Message Testing - 15/11/22 SMS',
        smallImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/55_f6e8f981d1b7497eaa0620deb850eef1.jpg',
        mediumImage:
          'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/m/55_ad5e8e8f38be48aa9e42f293f370d2f4.jpg',
        status: 'NEW',
        distributedDate: '2023-03-27T03:32:38',
        updatedDate: '2023-03-27T03:32:38',
        messageType: 'SHAREABLE',
      },
    ],
    paging: {
      total: 23,
      count: 10,
      totalPages: 3,
      currentPage: 0,
    },
  },
};
